// src/redux/contextRadar/contextRadarAPI.js
import apiClient from "../authentication/utils/core/axios";

const contextRadarAPI = {
  async getWatchlistEvents(tickers, limit = 5) {
    // Avoid calling backend with no tickers
    if (!tickers || tickers.length === 0) {
      return [];
    }

    try {
      // IMPORTANT FIX: FastAPI does NOT accept tickers[], so we must manually append
      const params = new URLSearchParams();
      tickers.forEach((t) => params.append("tickers", t));
      params.append("limit_per_ticker", limit);

      const response = await apiClient.get(
        `/context-radar/watchlist?${params.toString()}`
      );

      return response.data;
    } catch (error) {
      console.warn("contextRadarAPI getWatchlistEvents error:", error);
      throw error;
    }
  },

  async getTickerEvents(ticker, limit = 20) {
    // Avoid undefined tickers
    if (!ticker) {
      return [];
    }

    try {
      const response = await apiClient.get(`/context-radar/ticker/${ticker}`, {
        params: { limit },
      });
      return response.data;
    } catch (error) {
      console.warn("contextRadarAPI getTickerEvents error:", error);
      throw error;
    }
  },

  async getGlobalEvents(limit = 20) {
    try {
      const response = await apiClient.get(`/context-radar/global`, {
        params: { limit },
      });
      return response.data;
    } catch (error) {
      console.warn("contextRadarAPI getGlobalEvents error:", error);
      throw error;
    }
  },
};

export default contextRadarAPI;
